import { getField } from 'vuex-map-fields';

export default {
  invoiceList: state => state.invoiceList,
  invoice: state => state.invoice,
  publicInvoice: state => state.publicInvoice,
  nextInvoiceNumber: state => state.nextInvoiceNumber,
  totalRevenue: state => state.totalRevenue,
  invoiceCreated: state => state.invoiceCreated,
  invoiceDeleted: state => state.invoiceDeleted,
  loadingData: state => state.loadingData,
  checkoutSucceeded: state => state.checkoutSucceeded,
  calculatedTax: state => state.calculatedTax,
  apiError: state => state.apiError,
  getField,
};
